<template>
	<v-card>
		<v-card-title>
			<v-icon left color="primary">mdi-power-plug</v-icon>Integrações
			<v-spacer></v-spacer>
		</v-card-title>
		<v-card-text>
			<v-row>
				<v-col cols="12" md="6">
					<v-card class="pa-3">
						<v-card-title class="pa-0">AgroReceita</v-card-title>
						<v-row>
							<v-col cols="12">
								<v-text-field label="E-mail" :readonly="!editEnabled" v-model="config.agro_email"
									hide-details></v-text-field>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12">
								<v-text-field label="Senha" :readonly="!editEnabled" v-model="config.agro_senha"
									hide-details></v-text-field>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12">
								<v-text-field label="API Key" :readonly="!editEnabled" v-model="config.agro_apikey"
									hide-details></v-text-field>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12">
								<v-text-field label="Token" readonly v-model="config.agro_token"
									hide-details></v-text-field>
							</v-col>
						</v-row>
					</v-card>
					<v-card class="pa-3 mt-3">
						<v-card-title class="pa-0">Mercado Pago</v-card-title>
						<v-row>
							<v-col cols="12">
								<v-text-field label="Cliente ID (Número da integração)" :readonly="!editEnabled"
									v-model="config.mercadopago_client_id" hide-details></v-text-field>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12">
								<v-text-field label="Client Secret" :readonly="!editEnabled"
									v-model="config.mercadopago_client_secret" hide-details></v-text-field>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12">
								<v-text-field label="Url de Redirecionamento" :readonly="!editEnabled"
									v-model="config.mercadopago_redirect_url" hide-details></v-text-field>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
				<v-col sm="12" md="6">
					<v-card class="pa-3">
						<v-card-title class="pa-0">API Placas</v-card-title>
						<v-row>
							<v-col cols="12">
								<v-text-field label="Token API Placas" :readonly="!editEnabled"
									v-model="config.token_placas" hide-details></v-text-field>
							</v-col>
						</v-row>
					</v-card>
					<v-card class="pa-3 mt-3">
						<v-card-title class="pa-0">Consulta CPF(API Brasil)</v-card-title>
						<v-row>
							<v-col cols="12">
								<v-row>
									<v-col>
										<p class="mb-0 label">Tipo de consulta:</p>
										<v-radio-group v-model="config.apibrasil_tipo" row class="mt-0" hide-details>
											<v-radio label="Plano Contratado" :value="0" />
											<v-radio label="Por Crédito" :value="1" />
										</v-radio-group>
									</v-col>
								</v-row>
								<v-row>
									<v-col>
										<v-text-field label="Token API Brasil" :readonly="!editEnabled"
											v-model="config.apibrasil_token" hide-details class="mb-0" />
									</v-col>
								</v-row>
								<v-row>
									<v-col>
										<v-text-field label="Token Dispositivo" :readonly="!editEnabled"
											v-model="config.apibrasil_device_token" hide-details />
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</v-card>
					<v-card class="pa-3 mt-3">
						<v-card-title class="pa-0">PlugZap</v-card-title>
						<v-row>
							<v-col cols="12">
								<v-row>
									<v-col>
										<v-text-field label="Token Conta" :readonly="!editEnabled"
											v-model="config.plugzap_token_conta" hide-details class="mb-0" />
									</v-col>
								</v-row>
								<v-row>
									<v-col>
										<v-text-field label="Token Parceiro" :readonly="!editEnabled"
											v-model="config.plugzap_token_parceiro" hide-details />
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</v-card>
					<v-card class="pa-3 mt-3">
						<v-card-title class="pa-0">TecnoSpeed</v-card-title>
						<v-row>
							<v-col cols="12">
								<v-row>
									<v-col>
										<v-text-field label="Dfe: Token" :readonly="!editEnabled"
											v-model="config.dfe_token" hide-details class="mb-0" />
									</v-col>
								</v-row>
								<v-row>
									<v-col>
										<v-text-field label="PlugBoletos: Token" :readonly="!editEnabled"
											v-model="config.plugboleto_token" hide-details class="mb-0" />
									</v-col>
								</v-row>
								<v-row>
									<v-col>
										<v-text-field label="PlugStorage: Senha" :readonly="!editEnabled"
											v-model="config.plugstorage_senha" hide-details class="mb-0" />
									</v-col>
								</v-row>
								<v-row>
									<v-col>
										<v-text-field label="PlugStorage: Token" :readonly="!editEnabled"
											v-model="config.plugstorage_token" hide-details class="mb-0" />
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions>
			<v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
			<v-btn color="primary" v-if="editEnabled" @click="saveConfig" class="mr-1">Salvar</v-btn>
		</v-card-actions>
	</v-card>
</template>
<script>
import { mapGetters } from 'vuex'
import * as configService from '../services/configService'

export default {
	data: function () {
		return {
			config: {},
			loading: false,
		}
	},
	computed: {
		...mapGetters(['userAdmin', 'userIntegracoes']),
		editEnabled() {
			return !this.loading && (this.userAdmin || this.userIntegracoes)
		},
	},
	methods: {
		async loadConfig() {
			try {
				this.loading = true
				//const response = await this.axios.get('/integracoes')
				this.config = await configService.getIntegracoes();
			} catch (error) {
				this.$store.dispatch('showError', error)
			} finally {
				this.loading = false
			}
		},

		async saveConfig() {
			try {
				this.dialogLoading = true
				// eslint-disable-next-line no-console
                //console.log(this.config);
				//await this.axios.put('/integracoes', this.config)
				await configService.putIntegracoes(this.config);
				this.$store.dispatch('showSuccess', 'Configuração salva com sucesso')
				
				this.loadConfig()
			} catch (error) {
				this.$store.dispatch('showError', error)
			} finally {
				this.dialogLoading = false
			}
		},
	},
	mounted() {
		this.loadConfig()
	},
	watch: {
		pixTaxaJuros() {
			this.config.pixTaxaJuros = Number(this.pixTaxaJuros.replace(',', '.'))
		},
	},
}
</script>

<style scoped>
.label {
	color: grey;
}
</style>
